import 'jqwidgets-scripts/jqwidgets/styles/jqx.base.css' 
import 'jqwidgets-scripts/jqwidgets/styles/jqx.bootstrap.css' 

import 'jqwidgets-scripts/jqwidgets/jqxcore.js'
import 'jqwidgets-scripts/jqwidgets/jqxdata.js'
import 'jqwidgets-scripts/jqwidgets/jqxdata.export.js'
import 'jqwidgets-scripts/jqwidgets/jqxmenu.js'
import 'jqwidgets-scripts/jqwidgets/jqxlistbox.js'
import 'jqwidgets-scripts/jqwidgets/jqxdropdownlist.js'
import 'jqwidgets-scripts/jqwidgets/jqxcombobox.js'
import 'jqwidgets-scripts/jqwidgets/jqxnumberinput.js'
import 'jqwidgets-scripts/jqwidgets/jqxcheckbox.js'
import 'jqwidgets-scripts/jqwidgets/jqxcalendar.js'
import 'jqwidgets-scripts/jqwidgets/jqxnumberinput.js'
import 'jqwidgets-scripts/jqwidgets/jqxdatetimeinput.js'
import 'jqwidgets-scripts/jqwidgets/jqxbuttons.js'
import 'jqwidgets-scripts/jqwidgets/jqxscrollbar.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.edit.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.selection.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.filter.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.sort.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.grouping.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.export.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.columnsresize.js'
import 'jqwidgets-scripts/jqwidgets/jqxgrid.aggregates.js'

import installer from './defaults'

export * from './components' // 公开单个组件的使用
export * from './utils'      // 公开方法

export const install = installer.install 
export const version = installer.version

export default installer
